// extracted by mini-css-extract-plugin
export default {"tooltipIcon":"Fq_m3PkLKQVCEehsTd5O","labelWrapper":"zK2RCiusg7nHSEi7DcJ4","tooltip":"dxOtUy1mNNsr54jhHFqq"};